// extracted by mini-css-extract-plugin
export default {"RootLayout":"RootLayout_RootLayout__zigr7","ContentContainer":"RootLayout_ContentContainer__xhfew"};